import { REPORTS_NAMESPACE } from '../../../translations'

const namespace = `${REPORTS_NAMESPACE}--report-view-selector`

export const TRANSLATION_KEYS = {
  title: `${namespace}--title`,
  partnerView: `${namespace}--partner-view`,
  quarterlyView: `${namespace}--quarterly-view`,
  trendView: `${namespace}--trend-view`,
}
